// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

export enum ChatType {
    ROOM,
    SALES,
    KNOWLEDGE_BASE

}
export default ChatType
